module.exports = __webpack_public_path__ + "static/media/img_5.7bbf2b2a.png";